import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconPhotoPlaceholder = ({
  title = "Photo placeholder",
  viewBoxWidth = 160,
  viewBoxHeight = 160,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <defs>
      <rect id="a-PL" x="0" y="0" width="160" height="160" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M-544-3480H896v5400H-544z" />
      <g>
        <mask id="b-PL" fill="#fff">
          <use xlinkHref="#a-PL" />
        </mask>
        <use fill="#FFF" xlinkHref="#a-PL" />
        <g mask="url(#b-PL)">
          <path
            d="M80 252c38.66 0 70-41.34 70-80s-31.34-60-70-60-70 21.34-70 60 31.34 80 70 80z"
            fill="#EEF4F5"
          />
          <path
            d="M80 132c22.091 0 40-25.409 40-57.5C120 47.409 102.091 32 80 32S40 47.409 40 74.5c0 32.091 17.909 57.5 40 57.5z"
            fill="#D9E1E3"
          />
        </g>
      </g>
    </g>
  </Svg.Icon>
)

export default IconPhotoPlaceholder
